import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=7c2e2ce2&scoped=true&"
import script from "./categories.vue?vue&type=script&lang=js&"
export * from "./categories.vue?vue&type=script&lang=js&"
import style0 from "./categories.vue?vue&type=style&index=0&id=7c2e2ce2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2e2ce2",
  null
  
)

export default component.exports